import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { CodeValuePermitTeam, Permits2PermitEntity, PermitsV2MetaDataItemNames, PermitsV2MetaDataLookups } from '../meta-data/permitsv2-meta-data.service';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';

@DwCustomContextDefinition({
    keyName: 'permitV2CurrentUserPermitTeams',
    display: 'Permit V2 - Current User Permit Teams',
    isGlobal: true,
})
@Injectable()
export class PermitsV2CurrentUserPermitTeamsContext extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
           
            const permitTeamsList = this.getUserPermitTeams();

            const permitTeamString = permitTeamsList.join(',');
            
            return {
                PermitTeams: permitTeamString
            };
        });

        contextDef.attributes = [];
        var hasPermissionAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
                                                                        'PermitTeams', 'Permit Teams', 
                                                                         DwAttributeType.Integer, DwControlType.DropDownList);
        
        hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        hasPermissionAttr.Attribute.IsLookup = true;
        hasPermissionAttr.Attribute.MetaDataLookupId = PermitsV2MetaDataLookups.CodeValuePermitTeam;
    }

    private getUserPermitTeams(): number[] {
        const permitTeamIds : number[] = [];

        if (this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeCriticalPowerGrid)) {
            permitTeamIds.push(CodeValuePermitTeam.CRITICALPOWER);
        }
        if (this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeNESGrid)) {
            permitTeamIds.push(CodeValuePermitTeam.NES);
        }
        if (this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeNSPGrid)) {
            permitTeamIds.push(CodeValuePermitTeam.NSPLBU);
        }
        if (this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeOperationsSupportGrid)) {
            permitTeamIds.push(CodeValuePermitTeam.OperationsSupport);
        }
        if (this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeRolloutGrid)) {
            permitTeamIds.push(CodeValuePermitTeam.Rollout);
        }
        if (this.dwSecurityUserService.hasPermission(AppPermissions.permitsCanSeeWECGrid)) {
            permitTeamIds.push(CodeValuePermitTeam.WEC);
        }

        return permitTeamIds;
    }

}